import {Directory, Encoding, Filesystem} from "@capacitor/filesystem";
import {Share} from "@capacitor/share";
import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class ShareService {
  async share(conteudo: string, nome: string){
    await Filesystem.writeFile({
      data: conteudo,
      path: nome,
      directory: Directory.Cache,
      encoding: Encoding.UTF8,
    })
    const uri =await  Filesystem.getUri({
      directory: Directory.Cache,
      path: nome
    })
    await Share.share({
      url: uri.uri,
    });
  }

  async shareBinario(conteudo: Uint8Array, nome: string){
    const blob = new Blob([conteudo]);
    await Filesystem.writeFile({
      data: blob,
      path: nome,
      directory: Directory.Cache,
      encoding: Encoding.UTF8,
    })
    const uri =await  Filesystem.getUri({
      directory: Directory.Cache,
      path: nome
    })
    await Share.share({
      url: uri.uri,
    });
  }
}
